import { TherapistProps } from '@/components/therapists/TherapistCard';

export const therapistsData: TherapistProps[] = [
  {
    id: "th-001",
    name: "Dr. Sarah Johnson",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80",
    specialties: ["Anxiety", "Depression", "Trauma"],
    rating: 4.9,
    reviewCount: 127,
    isOnline: true,
    location: "New York, USA",
    price: 120,
    currency: "$",
    available: true,
    languages: ["English", "Spanish"],
    sessionCount: 342,
    summary: "I specialize in evidence-based approaches for anxiety and depression, with over 10 years of experience helping clients develop practical coping strategies and achieve lasting positive change."
  },
  {
    id: "th-002",
    name: "Dr. Michael Chen",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    specialties: ["Relationship Issues", "Grief", "Work Stress"],
    rating: 4.8,
    reviewCount: 98,
    isOnline: true,
    location: "San Francisco, USA",
    price: 135,
    currency: "$",
    available: true,
    languages: ["English", "Mandarin"],
    sessionCount: 256,
    summary: "I help individuals navigate relationship challenges, grief, and work-related stress using a client-centered approach that emphasizes personal growth and improved wellbeing."
  },
  {
    id: "th-003",
    name: "Dr. Emma Rodriguez",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Anxiety", "Self-Esteem", "Life Transitions"],
    rating: 4.7,
    reviewCount: 84,
    isOnline: true,
    location: "London, UK",
    price: 110,
    currency: "£",
    available: true,
    languages: ["English", "Spanish"],
    sessionCount: 198,
    summary: "My approach combines cognitive behavioral techniques with mindfulness to help clients manage anxiety, build self-esteem, and navigate important life transitions with confidence."
  },
  {
    id: "th-004",
    name: "Dr. James Wilson",
    image: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1160&q=80",
    specialties: ["Depression", "Addiction", "PTSD"],
    rating: 4.9,
    reviewCount: 142,
    isOnline: true,
    location: "Toronto, Canada",
    price: 125,
    currency: "C$",
    available: false,
    languages: ["English", "French"],
    sessionCount: 312,
    summary: "With specialized training in trauma treatment and addiction recovery, I provide compassionate care for individuals dealing with complex challenges including PTSD and depression."
  },
  {
    id: "th-005",
    name: "Dr. Sofia Garcia",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1722&q=80",
    specialties: ["Family Therapy", "Child Psychology", "Parenting"],
    rating: 4.8,
    reviewCount: 113,
    isOnline: true,
    location: "Madrid, Spain",
    price: 95,
    currency: "€",
    available: true,
    languages: ["Spanish", "English"],
    sessionCount: 287,
    summary: "As a family therapy specialist, I work with parents and children to improve communication, resolve conflicts, and create healthier family dynamics through collaborative therapeutic approaches."
  },
  {
    id: "th-006",
    name: "Dr. Thomas Mueller",
    image: "https://images.unsplash.com/photo-1556157382-97eda2f9e2bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    specialties: ["Anxiety", "CBT", "Mindfulness"],
    rating: 4.6,
    reviewCount: 76,
    isOnline: true,
    location: "Berlin, Germany",
    price: 105,
    currency: "€",
    available: true,
    languages: ["German", "English"],
    sessionCount: 145,
    summary: "I offer a range of therapeutic services, including CBT and mindfulness, to help clients manage anxiety and improve their overall well-being."
  },
  {
    id: "th-007",
    name: "Dr. Luisa Fernandez",
    image: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Trauma Recovery", "EMDR", "Anxiety Disorders"],
    rating: 4.9,
    reviewCount: 156,
    isOnline: true,
    location: "Barcelona, Spain",
    price: 90,
    currency: "€",
    available: true,
    languages: ["Spanish", "English", "Catalan"],
    sessionCount: 329,
    summary: "I specialize in trauma recovery and EMDR to help clients overcome anxiety and other mental health challenges."
  },
  {
    id: "th-008",
    name: "Dr. Ricardo Montoya",
    image: "https://images.unsplash.com/photo-1615813967515-e1838c1c5116?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
    specialties: ["Depression", "Couples Therapy", "Grief"],
    rating: 4.7,
    reviewCount: 92,
    isOnline: true,
    location: "Mexico City, Mexico",
    price: 80,
    currency: "$",
    available: true,
    languages: ["Spanish", "English"],
    sessionCount: 175,
    summary: "I provide therapy for depression, couples, and grief, using a holistic approach that addresses both emotional and physical well-being."
  },
  {
    id: "th-009",
    name: "Dr. Isabella Rossi",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    specialties: ["Eating Disorders", "Body Image", "Self-Esteem"],
    rating: 4.8,
    reviewCount: 108,
    isOnline: true,
    location: "Rome, Italy",
    price: 110,
    currency: "€",
    available: true,
    languages: ["Italian", "English"],
    sessionCount: 231,
    summary: "I specialize in eating disorders, body image issues, and self-esteem challenges, providing individual and group therapy to help clients achieve their goals."
  },
  {
    id: "th-010",
    name: "Dr. Ana Lopez",
    image: "https://images.unsplash.com/photo-1550945771-515f118cef86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    specialties: ["Anxiety", "OCD", "Panic Disorders"],
    rating: 4.9,
    reviewCount: 131,
    isOnline: true,
    location: "Buenos Aires, Argentina",
    price: 75,
    currency: "$",
    available: true,
    languages: ["Spanish", "English"],
    sessionCount: 267,
    summary: "I offer therapy for anxiety, OCD, and panic disorders, using a combination of cognitive behavioral techniques and mindfulness to help clients manage their symptoms."
  },
  {
    id: "th-011",
    name: "Dr. Carlos Mendez",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Adolescent Therapy", "Family Conflict", "School Issues"],
    rating: 4.6,
    reviewCount: 87,
    isOnline: true,
    location: "Santiago, Chile",
    price: 85,
    currency: "$",
    available: true,
    languages: ["Spanish", "English"],
    sessionCount: 163,
    summary: "I specialize in adolescent therapy, family conflict, and school issues, providing individual and group therapy to help clients navigate these challenges."
  },
  {
    id: "th-012",
    name: "Dr. Maria Gonzalez",
    image: "https://images.unsplash.com/photo-1598257006458-087169a1f08d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Stress Management", "Work-Life Balance", "Burnout"],
    rating: 4.7,
    reviewCount: 104,
    isOnline: true,
    location: "Miami, USA",
    price: 115,
    currency: "$",
    available: true,
    languages: ["Spanish", "English"],
    sessionCount: 219,
    summary: "I provide therapy for stress management, work-life balance, and burnout, using a holistic approach that addresses both emotional and physical well-being."
  },
  {
    id: "th-013",
    name: "Dr. Elena Petrov",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
    specialties: ["Cognitive Behavioral Therapy", "Depression", "Anxiety"],
    rating: 4.8,
    reviewCount: 118,
    isOnline: true,
    location: "Moscow, Russia",
    price: 95,
    currency: "$",
    available: true,
    languages: ["Russian", "English"],
    sessionCount: 247,
    summary: "I offer CBT and other evidence-based therapies for depression and anxiety, using a personalized approach to help clients achieve their goals."
  },
  {
    id: "th-014",
    name: "Dr. Alexei Ivanov",
    image: "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
    specialties: ["Psychoanalysis", "Trauma", "Addiction Recovery"],
    rating: 4.7,
    reviewCount: 93,
    isOnline: false,
    location: "St. Petersburg, Russia",
    price: 90,
    currency: "$",
    available: true,
    languages: ["Russian", "English", "German"],
    sessionCount: 186,
    summary: "I provide psychoanalysis and other therapeutic approaches for trauma, addiction, and other mental health challenges."
  },
  {
    id: "th-015",
    name: "Dr. Hiroshi Tanaka",
    image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Mindfulness Therapy", "Work Stress", "Cross-cultural Issues"],
    rating: 4.9,
    reviewCount: 136,
    isOnline: true,
    location: "Tokyo, Japan",
    price: 130,
    currency: "$",
    available: true,
    languages: ["Japanese", "English"],
    sessionCount: 274,
    summary: "I offer mindfulness therapy and other therapeutic approaches for work stress and cross-cultural issues, using a personalized approach to help clients achieve their goals."
  },
  {
    id: "th-016",
    name: "Dr. Amina Patel",
    image: "https://images.unsplash.com/photo-1532074205216-d0e1f4b87368?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80",
    specialties: ["Cultural Adjustment", "Identity", "Relationship Issues"],
    rating: 4.9,
    reviewCount: 128,
    isOnline: true,
    location: "Mumbai, India",
    price: 85,
    currency: "$",
    available: true,
    languages: ["Hindi", "English", "Gujarati"],
    sessionCount: 253,
    summary: "I provide therapy for cultural adjustment, identity issues, and relationship challenges, using a personalized approach to help clients achieve their goals."
  }
];
